import moment    from 'moment'
import Countdown from 'react-countdown';
import React     from 'react'

import { OnSchedUtils } from '../../../utils';


const AppointmentDetails = ({ element, appointment, bookingTimerMins }) => {
  const timer = bookingTimerMins ? bookingTimerMins : 2;

  if (!appointment || element.options.appointmentDetails === false)
    return null

  let duration = appointment.serviceDuration ? appointment.serviceDuration + ' min' : ''
  
  if (appointment.object === 'appointment') {
    duration = appointment.duration ? appointment.duration + ' min' : ''
  }
  
  return (
    <div>
      <h5 className='AvailabilityCalendarTitle'>
        <i className="onsched-primary-color fa-light fa-memo-circle-info"></i>
        
        {appointment.serviceName}&nbsp;
        {OnSchedUtils.Internationalize(element, 'utility_with')}&nbsp;
        {appointment.resourceName}&nbsp;{moment(appointment.startDateTime).format('MMM Do, h:mma')}&nbsp;
        {OnSchedUtils.Internationalize(element, 'utility_to')}&nbsp;
        {moment(appointment.endDateTime).format('MMM Do, h:mma')}&nbsp;
        {OnSchedUtils.Internationalize(element, 'consumer_availability_booking_form_expiration')}&nbsp;

        <Countdown 
          date={Date.now() + (timer * 60000 - 1000)} 
          daysInHours={true}
          zeroPadTime={2}
          renderer={({ hours, minutes, seconds, completed }) => {
            if (completed) {
              // Render a completed state
              cancel();
              OnSchedUtils.Toast(element, { error: true, message: OnSchedUtils.Internationalize(element, 'consumer_availability_booking_form_expired') })
              return null;
            } else {
              // Render a countdown
              return <span>{minutes}:{seconds}</span>;
            }
          }}
        />
        &nbsp;{OnSchedUtils.Internationalize(element, 'consumer_availability_booking_form_minutes')}
      </h5>
    </div>
  )
}

export default AppointmentDetails